module.exports = __webpack_public_path__ + "dash_20_app_assets/img/card-image-6.b26faf1e.jpg";